module.exports = __webpack_public_path__ + "static/media/Industrial-Construction.1da56ebf.jpg";